(function () {
    'use strict';

    var imApp = angular.module('imApp');

    imApp.component('productStructures', {
        templateUrl: 'views/components/views/productStructures/productStructures.template.html?v=' + imApp.version,
        controllerAs: 'vm',
        controller: [
            'productStructuresService',
            'stateService',
            'utilityService',
            'ttGridFactory',
            'rememberService',
            'productService',
            function (
                productStructuresService,
                stateService,
                utilityService,
                ttGridFactory,
                rememberService,
                productService
            ) {

                // #region VARIABLES & DEFINITIONS

                const vm = this;

                let variableNames = {
                    prodtype_no: '',
                    searchtext_product: '',
                    searchtext_component: '',
                };

                vm.model = {
                    gridComponentsReady: false,                    
                    prodtypeButtons: [{ id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('prodtype_no') }],
                    searchTextProductButtons: [
                        { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext_product') },
                        { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => searchGrid() },
                    ],
                    searchTextComponentButtons: [
                        { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext_component') },
                        { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => searchGrid() },
                    ],

                    setting: {},
                    selectListProdtypes: [],
                };

                vm.gridComponents = new ttGridFactory({
                    rememberId: 'w_productstructures_components_grid',
                    kendo: {
                        height: '100%',
                        sortable: true,
                        aggregate: true,
                        pager: false,
                        selectable: false,
                        filterable: false,
                    },
                }).setToolbar({ wrapping: true });

                // #endregion VARIABLES & DEFINITIONS

                // #region LOAD PROCEDURE FUNCTION CALLS

                async function loadSetting() {
                    vm.model.setting = (await productStructuresService.getSetting())[0];
                }

                async function loadProdtypes() {
                    vm.model.selectListProdtypes = await productService.listProductTypes();
                }

                // #endregion LOAD PROCEDURE FUNCTION CALLS

                // #region GRID PROCEDURE FUNCTION CALLS

                async function loadGridComponents() {
                    vm.gridComponents.dataTask.loadData = {
                        method: 3975,
                        parameters: vm.model.setting,
                    };

                    vm.model.gridComponentsReady = true;

                    if (vm.gridComponents.gridfunc !== null) vm.gridComponents.gridfunc.read();
                }

                // #endregion GRID PROCEDURE FUNCTION CALLS

                // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                function rememberFunc(id) {
                    Object.keys(variableNames).forEach((key) => {
                        switch (key) {
                            case '':
                                break;
                            default:
                                variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                                break;
                        }
                    });

                    if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                    let variableValue = null;

                    switch (id) {
                        case 'searchtext_product':
                        case 'searchtext_component':
                        case 'prodtype_no':
                            if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                            variableValue = vm.model.setting[id];
                            break;
                        default:
                            break;
                    }

                    return rememberService.remember(variableNames[id], variableValue);
                }

                // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

                // #region CLEAR SEARCH GRID FUNCTION

                async function clearSearchGrid() {
                    let loadGrid = 0;
                    if (vm.model.setting.searchtext_product === '') {
                        rememberFunc('searchtext_product');
                        loadGrid = 1;
                    }
                    if (vm.model.setting.searchtext_component === '') {
                        rememberFunc('searchtext_component');
                        loadGrid = 1;                        
                    }
                    if (loadGrid > 0) {
                        await loadGridComponents();
                        loadGrid = 0;
                    }
                }

                // #endregion CLEAR SEARCH GRID FUNCTION

                // #region SEARCH GRID FUNCTION

                async function searchGrid() {
                    let loadGrid = 0;
                    if (vm.model.setting.searchtext_product > '') {
                        rememberFunc('searchtext_product');
                        loadGrid = 1;
                    }
                    if (vm.model.setting.searchtext_component > '') {
                        rememberFunc('searchtext_component');
                        loadGrid = 1;                        
                    }
                    if (loadGrid > 0) {
                        await loadGridComponents();
                        loadGrid = 0;
                    }
                }

                // #endregion SEARCH GRID FUNCTION

                // #region CLEAR BUTTON FUNCTION

                function clear(id) {
                    switch (id) {
                        case 'prodtype_no':
                            vm.model.setting[id] = '';

                            if (vm.model.setting[id] === '') {
                                rememberFunc(id);
                                loadGridComponents();
                            }
                            break;
                        case 'searchtext_product':
                            vm.model.setting.searchtext_product = '';

                            clearSearchGrid();
                            break;
                        case 'searchtext_component':
                            vm.model.setting.searchtext_component = '';

                            clearSearchGrid();
                            break;

                        default:
                            break;
                    }
                }

                // #endregion CLEAR BUTTON FUNCTION

                // #region SEARCH ENTER FUNCTION

                vm.searchItems = function () {
                    searchGrid();
                };

                // #endregion SEARCH ENTER FUNCTION

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = async function (value, id) {
                    switch (id) {
                        case 'prodtype_no':
                            if (utilityService.validateWatchValue(value, vm.model.setting.prodtype_no) !== true) return;

                            vm.model.setting.prodtype_no = value;

                            if (utilityService.validateParmsValue(vm.model.setting.prodtype_no, true) !== true) return;

                            rememberFunc('prodtype_no');
                            await loadGridComponents();
                            break;
                        case 'searchtext_product':
                            if (utilityService.validateWatchValue(value, vm.model.setting.searchtext_product) !== true) return;

                            vm.model.setting.searchtext_product = value;

                            if (utilityService.validateParmsValue(vm.model.setting.searchtext_product, true) !== true) return;

                            clearSearchGrid();
                            break;
                        case 'searchtext_component':
                            if (utilityService.validateWatchValue(value, vm.model.setting.searchtext_component) !== true) return;

                            vm.model.setting.searchtext_component = value;

                            if (utilityService.validateParmsValue(vm.model.setting.searchtext_component, true) !== true) return;

                            clearSearchGrid();
                            break;

                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region ON INIT FUNCTION

                vm.$onInit = async function () {
                    await loadSetting();
                    loadProdtypes();
                    loadGridComponents();
                };

                // #endregion ON INIT FUNCTION

        }]
    });
})();
